import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { useStyles } from './Loading.styles';

export const Loading = (props: { size?: number }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <CircularProgress size={props.size || 68} />
    </div>
  );
};

export default Loading;
